<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="warn" type="button" (click)="confirm()">Delete</button>
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
